import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setNextPage } from '../../../redux/slices/appStateSlice';
import { resetSpouse, resetChildren } from '../../../redux/slices/quoteDataSlice';

const WhoToCoverLogic = ({ fields, addOthers }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (addOthers === 'true') {
      dispatch(setNextPage(fields.addOthersNextPage?.value?.href));
    } else {
      dispatch(resetSpouse());
      dispatch(resetChildren());
      dispatch(setNextPage(fields.noOthersNextPage?.value?.href));
    }
  }, [addOthers]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    addOthers: state.appState?.addOthers,
  };
};
export default connect(mapStateToProps)(WhoToCoverLogic);
